import React from "react";
import Context from "../../../../../Context";
import Blocker from "../../../../Misc/Blocker";
import AreaUsers from "./AreaUsers";
export default class ItemView extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = this.init();
  }

  getChildren = (items, seekId, level) => {
    let children = {};

    Object.entries(items).forEach(([id, item]) => {
      if (String(item.parent) === seekId) {
        children[id] = { ...item, level };
        children = Object.assign(
          children,
          this.getChildren(items, id, level + 1)
        );
      }
    });
    return children;
  };

  init = (set = false) => {
    let items = this.props.data || {};
    let item = items[this.props.activeItem] || {};
    let types = this.props.types || {};

    let itemsOrdered = {};
    Object.entries(items).forEach(([id, item]) => {
      if (item.level === 0)
        itemsOrdered = Object.assign(
          itemsOrdered,
          this.getChildren(items, id, 0)
        );
    });

    let state = {
      pending: false,
      editable: this.props.activeItem && item["parent"] ? true : false,
      addable: true,
      deletable: this.props.activeItem && item["parent"] ? true : false,
      edit: false,
      add: false,
      formDefaultsEdit: {
        name: item.name,
        code: item.code,
        type: item.type,
        parent: item.parent,
        description: item.description,
      },
      formDefaultsAdd: {
        name: "",
        code: "",
        type: item.type,
        parent: item.parent,
        description: "",
      },
      form: {
        name: "",
        code: "",
        type: "",
        parent: "",
        description: "",
      },
      formErrors: {
        name: false,
        code: false,
        type: false,
        parent: false,
      },
      errors: [],
      item,
      items,
      itemsOrdered,
      types,
    };
    if (set) {
      this.setState(state);
    }
    return state;
  };

  getItemPath = (item) => {
    if (item) {
      let path = [item.name];
      let parent = item.parent;
      while (parent) {
        let parentItem = this.state.items[parent];
        if (parentItem) {
          path.push(parentItem.name);
          parent = parentItem.parent;
        } else {
          break;
        }
      }
      return path.reverse().join(" \\ ");
    }
  };

  changeForm = (id, value) => {
    this.setState((state) => {
      let form = state.form;
      let formErrors = state.formErrors;
      formErrors[id] = false;
      form[id] = value;
      return { form, formErrors };
    });
  };

  date(v) {
    if (v) {
      let date = new Date(v);
      return date ? date.toLocaleString() : "-";
    } else {
      return "-";
    }
  }

  switchToEdit = () => {
    if (this.state.add) {
      this.setState({
        add: false,
        edit: true,
        form: this.state.formDefaultsEdit,
      });
    } else if (this.state.edit) {
      this.setState({
        add: false,
        edit: false,
        form: this.state.formDefaultsEdit,
      });
    } else {
      this.setState({
        add: false,
        edit: true,
        form: this.state.formDefaultsEdit,
      });
    }
  };

  switchToAdd = () => {
    if (this.state.add) {
      this.setState({
        add: false,
        edit: false,
        form: this.state.formDefaultsAdd,
      });
    } else if (this.state.edit) {
      this.setState({
        add: true,
        edit: true,
        form: this.state.formDefaultsAdd,
      });
    } else {
      this.setState({
        add: true,
        edit: true,
        form: this.state.formDefaultsAdd,
      });
    }
  };

  cancell = () => {
    this.setState({ add: false, edit: false });
  };

  deleteClick = () => {
    let itemCaption = this.state.item["name"];
    this.context
      .ask(
        `Вы действительно хотите удалить подразделение ${itemCaption}`,
        "Удаление подразделения",
        "question"
      )
      .then((answer) => {
        if (answer.value) {
          this.delete();
        }
      });
  };

  delete = async () => {
    this.setState({ pending: true });
    let item = this.state.item;
    let result = await this.context.api.q("/admin/area/delete/safely", {
      id: item.id,
    });

    this.setState({ pending: false });

    if (result) {
      if (result.result) {
        this.context.toast(`${item.name}: Подразделение удалено`, "success");
        await this.props.changeFn();
        this.init(true);
        return;
      }
    }

    this.context.toast(
      `${item.name}: Не удалось удалить подразделение`,
      "error"
    );
  };

  save = async () => {
    let errors = this.validate();
    if (!errors.length) {
      let data = {
        id: this.state.add ? null : this.state.item.id,
        parent: this.state.form.parent,
        type: this.state.form.type,
        code: this.state.form.code,
        name: this.state.form.name,
        description: this.state.form.description,
      };
      this.setState({ pending: true });

      let result = await this.context.api.q("/admin/area/set", data);
      if (result !== false) {
        this.context.toast(
          `${data.name}: Подразделение успешно сохранено`,
          "success"
        );
        this.setState({ edit: false });
        await this.props.changeFn(result["id"]);
        this.init(true);
      } else {
        this.context.toast(
          `${data.name}: Не удалось сохранить подразделение`,
          "error"
        );
      }

      this.setState({ pending: false });
    }
  };

  validate = () => {
    let errors = [];
    let formErrors = {
      name: false,
      code: false,
      type: false,
      parent: false,
    };
    let form = this.state.form;
    if (!form.name) {
      errors.push("Не заполнено наименование подразделения");
      formErrors.name = true;
    }
    if (!form.code) {
      errors.push("Не указан код подразделения");
      formErrors.code = true;
    }
    if (!form.type) {
      errors.push("Не выбран тип подразделения");
      formErrors.type = true;
    }
    if (!form.parent) {
      errors.push("Выберите родительское подразделение");
      formErrors.parent = true;
    }
    this.setState({ formErrors, errors });
    return errors;
  };

  componentDidMount() {
    this.context.actionsSet(this.renderButtons());
  }
  componentDidUpdate() {
    this.context.actionsSet(this.renderButtons());
  }

  render() {
    let item = this.state.item || {};
    let title = item ? this.getItemPath(item) : "";
    if (this.state.add) title = "Добавление подразделения";
    if (this.state.item["parent"] || this.state.add) {
      return (
        <div>
          <div className="d-flex justify-content-between align-items-center mb-5">
            <h6 className="text-muted pr-10">{title}</h6>
          </div>
          {this.state.edit
            ? this.renderEditForm(item)
            : this.renderViewForm(item)}
        </div>
      );
    } else {
      return <></>;
    }
  }

  //Renders control buttons
  renderButtons() {
    return (
      <div className="text-nowrap">
        {this.state.editable ? (
          <button
            title="Редактировать подразделение"
            onClick={this.switchToEdit}
            className={`btn ${
              this.state.edit && !this.state.add
                ? "btn-light-primary"
                : "btn-light"
            } p-2 mr-2`}
          >
            <span className="flaticon2-edit px-2 align-middle"></span>
          </button>
        ) : null}
        {this.state.addable ? (
          <button
            title="Добавить подразделение"
            onClick={this.switchToAdd}
            className={`btn ${
              this.state.edit && this.state.add
                ? "btn-light-primary"
                : "btn-light"
            } p-2  mr-2`}
          >
            <span className="flaticon2-add-1 px-2 align-middle"></span>
          </button>
        ) : null}
        {this.state.deletable ? (
          <button
            title="Удалить подразделение"
            onClick={this.deleteClick}
            className={"btn btn-light p-2 text-hover-danger"}
          >
            <span className="flaticon2-rubbish-bin px-2 align-middle"></span>
          </button>
        ) : null}
      </div>
    );
  }

  //Renders VIEW form
  renderViewForm(item) {
    let parentName = this.state.items[item.parent]
      ? this.state.items[item.parent].name
      : "";
    return (
      <div>
        <table className="table">
          <tbody>
            <tr>
              <td>Тип</td>
              <td>{item.typename}</td>
            </tr>
            <tr>
              <td width="35%">Родитель</td>
              <td>{parentName}</td>
            </tr>
            <tr>
              <td>Наименование</td>
              <td> {item.name}</td>
            </tr>
            <tr>
              <td>Код</td>
              <td>{item.code}</td>
            </tr>
            <tr>
              <td>Описание</td>
              <td> {item.description}</td>
            </tr>

            <tr>
              <td>Id</td>
              <td>{item.id}</td>
            </tr>
            <tr>
              <td>Дата начала активности</td>
              <td>{this.date(item.validfromdate)}</td>
            </tr>
            <tr>
              <td>Дата окончания активности</td>
              <td>{this.date(item.validtodate)}</td>
            </tr>
          </tbody>
        </table>
        <AreaUsers id={item["id"]} key={item["id"]} item={item} />
      </div>
    );
  }

  //Renders EDIT form
  renderEditForm(item) {
    let errors = this.state.errors.length ? (
      <div className="alert alert-danger">
        <ul className="m-0 py-3">
          {this.state.errors.map((err) => (
            <li key={err}>{err}</li>
          ))}
        </ul>
      </div>
    ) : null;
    return (
      <Blocker on={this.state.pending}>
        <div className="px-lg-25">
          <div className="form-group">
            <label>Тип</label>
            <select
              id="type"
              className={`form-control ${
                this.state.formErrors.type ? "invalid" : ""
              }`}
              value={this.state.form.type}
              onChange={(e) => this.changeForm(e.target.id, e.target.value)}
            >
              <option></option>
              {Object.entries(this.state.types).map(([id, item]) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Родитель</label>
            <select
              id="parent"
              className={`form-control ${
                this.state.formErrors.parent ? "invalid" : ""
              }`}
              value={this.state.form.parent}
              onChange={(e) => this.changeForm(e.target.id, e.target.value)}
            >
              <option></option>
              {Object.entries(this.state.itemsOrdered).map(([id, item]) => (
                <option key={id} value={id}>
                  {" . . ".repeat(item.level)} {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Наименование</label>
            <input
              id="name"
              className={`form-control ${
                this.state.formErrors.name ? "invalid" : ""
              }`}
              value={this.state.form.name}
              onChange={(e) => this.changeForm(e.target.id, e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Код</label>
            <input
              id="code"
              className={`form-control ${
                this.state.formErrors.code ? "invalid" : ""
              }`}
              value={this.state.form.code}
              onChange={(e) => this.changeForm(e.target.id, e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Описание</label>
            <input
              id="description"
              className="form-control"
              value={this.state.form.description}
              onChange={(e) => this.changeForm(e.target.id, e.target.value)}
            />
          </div>

          {errors}
          <button className="btn btn-primary mr-2" onClick={this.save}>
            Сохранить
          </button>
          <button className="btn btn-light" onClick={this.cancell}>
            Отмена
          </button>
        </div>
      </Blocker>
    );
  }
}
